'use strict'

import Archives from '../wp_components/Archives'

export default class Filters
{
  constructor()
  {
    this.$elem = $('.Filters')

    if( this.$elem.length > 0 ){
      let self = this

      $(document).ready(function(){
        self._filterNews()
      })

      $(window).resize( ()=> {

      })

      $(window).on("orientationchange", ()=> {

      })

      $( window ).scroll( ()=> {

      })
    }
  }

  static _changeSearchs( arg ) { $('#typenews').val(arg) }

  _filterNews()
  {
    this.$elem.on('submit', function() {
      let typenews = $('#typenews').val()
      let search = $('#filterNews').val()
      let $loader = $('.loader_theme')

      $('.' + typenews).html('')
      $loader.addClass('active')
      $loader.fadeIn(function(){
          //Sidebar.resizeContainer()
      })

      $.ajax({
        method: "POST",
        url: ajaxurl,
        data: {action: "post_searchnews", search: search, typenews: typenews}
      }).done(function (response) {
        $('.' + typenews).html(response)
        $('.' + typenews).children().hide()

        $loader.fadeOut('slow', function(){
          $loader.removeClass('active')

          $('.' + typenews).children().fadeIn('slow', function(){
            //Sidebar.resizeContainer()
            Archives._adjustSizesItems()
          })
        })
      })

      return false
    })
  }
}

